import React, { useState } from 'react';
import { Paper, Tab, Tabs, Grid2 } from '@mui/material';

// COMPONENTES
import UnidadesActivas from '../unidadesActivas/componentes/unidadesActiva/UnidadesActivas';
import Sukarne from '../unidadesActivas/componentes/sukarne/Sukarne';
import Bafar from '../unidadesActivas/componentes/bafar/Bafar';
import Mondelez from '../unidadesActivas/componentes/mondelez/Mondelez';

const Telemetria = () => {

    const [tabValue, setTabValue] = useState(0);

    const handleChange = (event, newValue) => {

        setTabValue(newValue);

    };

    const catalogoComponentes = {

        0: <UnidadesActivas />,
        1: <Sukarne />,
        2: <Bafar />,
        3: <Mondelez />,

    }

    const ComponenteActual = catalogoComponentes[tabValue];

    return (

        <Paper sx={{ padding: 2 }}>

            <Grid2 container spacing={2}>

                {/* TABS */}

                <Grid2 size={12}>

                    <Tabs 
                        value={tabValue} 
                        onChange={handleChange} 
                        aria-label="basic tabs example"
                        centered
                    >
                        <Tab label="Unidades Activas" />
                        <Tab label="SuKarne" />
                        <Tab label="Bafar" />
                        <Tab label="Mondelez" />
                    </Tabs>

                </Grid2>

                {/* COMPONENTE ACTUAL */}

                <Grid2 size={12}>

                    {ComponenteActual}

                </Grid2>

            </Grid2>

        </Paper>

    )

}

export default Telemetria